import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';

// Prevent zoom on iOS Safari
document.addEventListener('gesturestart', function (e) {
  e.preventDefault();
});
document.addEventListener('touchmove', function (e) {
  // @ts-ignore
  if (e.scale && e.scale !== 1) {
    e.preventDefault();
  }
}, { passive: false });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Toaster position="top-center" />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);